// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1pvIn","actions":"GroupTable_actions__wgiDQ","deleteModalFooter":"GroupTable_deleteModalFooter__1jU4l"};